// import { test, enforce, create } from 'vest'

// export const formValidation = create((data = {}) => {
//   const { password, password_repeat } = data

//   test('password', 'Password cannot be empty', () => {
//     enforce(password).isNotEmpty()
//   })

//   test('password_repeat', 'Password cannot be empty', () => {
//     enforce(password_repeat).isNotEmpty()
//   })

//   test('password_repeat', 'Passwords must match', () => {
//     enforce(password_repeat).equals(password)
//   })
// })


import { create, test, enforce } from 'vest';

export const formValidation = create('ResetPasswordForm', (data = {}) => {
  const { password, password_repeat } = data;

  // Password required
  test('password', 'Password cannot be empty', () => {
    enforce(password).isNotEmpty();
  });

  // Password complexity rules
  test('password', 'Password must be at least 8 characters long', () => {
    enforce(password).longerThanOrEquals(8);
  });

  test('password', 'Password must contain at least one uppercase letter', () => {
    enforce(password).matches(/[A-Z]/);
  });

  test('password', 'Password must contain at least one lowercase letter', () => {
    enforce(password).matches(/[a-z]/);
  });

  test('password', 'Password must contain at least one number', () => {
    enforce(password).matches(/[0-9]/);
  });

  test('password', 'Password must contain at least one special character (!@#$%^&*)', () => {
    enforce(password).matches(/[!@#$%^&*(),.?":{}|<>]/);
  });

  // Confirm Password required
  test('password_repeat', 'Confirm password cannot be empty', () => {
    enforce(password_repeat).isNotEmpty();
  });

  // Confirm Password matches
  test('password_repeat', 'Passwords must match', () => {
    enforce(password_repeat).equals(password);
  });
});
